<template>
  <div class="wrap-tab-box f-tal">
    <div class="f-df f-ai bg-white tab-box">
      <el-tabs
        v-model="tabActive"
        class="tab-main-con mg-left30"
        @tab-click="tabChange()">
        <el-tab-pane
          v-for="item in tabPaneList"
          :key="item.id"
          :label="item.label"
          :name="item.route"/>
      </el-tabs>
    </div>
    <router-view v-if="!$route.meta.keepAlive" />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- <router-view class="pd15 mg-top10 wrap-bg" /> -->
    <!-- <keep-alive>
      <router-view class="pd15 mg-top10 wrap-bg" />
    </keep-alive> -->
  </div>
</template>

<script>
export default {
  props: {
    paramObj: {
      type: Object,
      default: () => {}
    },
    tabPaneList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      tabActive: this.tabPaneList[0].id
    }
  },
  watch: {
    // 监听路由变化
    $route(to) {
      const activeItem = this.tabPaneList.find(item => item.route === to.path || (item.pathGroup && item.pathGroup.indexOf(to.path) >= 0))
      if (activeItem) this.tabActive = activeItem.route
    },
    tabPaneList: {
      handler(newArr) {
        const currentPath = this.$route.path
        const activeItem = newArr.find(item => item.route === currentPath || (item.pathGroup && item.pathGroup.indexOf(currentPath) >= 0))
        if (activeItem) this.tabActive = activeItem.route
      },
      immediate: true, // 首次也监听
      deep: true
    }
  },
  methods: {
    // tab切换
    tabChange() {
      // 表格展示内容修改
      this.$router.replace({
        path: this.tabActive
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.tab-box{
  position: fixed;
  top: 0;
  width: calc(~'100vw - 208px');
  z-index: 10;
}
/deep/.el-tabs__header{
  background-color: @color-white;
  & .el-tabs__header{
    margin-bottom: 0px;
  }
  & .el-tabs__nav-wrap::after{
    height: 0px;
  }
}
</style>
